import { render } from "./collectAllItems.vue?vue&type=template&id=63f3c852&scoped=true"
import script from "./collectAllItems.vue?vue&type=script&lang=js"
export * from "./collectAllItems.vue?vue&type=script&lang=js"

import "./collectAllItems.vue?vue&type=style&index=0&id=63f3c852&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f3c852"]])

export default __exports__